import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import { reducer } from './reducer'
import { Chart } from './Chart'
import Config from './Config'
import './logo.scss'

export default widgetService.register({
    type: 'statusbar',
    get name() {
        return 'Status Bar'
    },
    get description() {
        return ''
    },
    config: {
        borderRadius: 7,
        pointWidth: 20,
        showCurrentDay: false,
        scrollbar: false,
        maxScrollbarItems: 4,
        description: true
    },
    //@ts-ignore
    ui: { configForm: Config },
    policies: { defaultReducer: '', layers: 1 },
    impl: reactWidgetWrapper<ChartState, ChartMessage>(Chart, reducer)
})
